import React from "react";
import { Tooltip } from "antd";

interface DurationBadgeProps {
  duration: string;
  tooltip: string;
}

/**
 * Duration badge component for displaying time periods
 * Shows a compact badge (e.g., "24h", "30d") with a tooltip on hover
 */
export const DurationBadge: React.FC<DurationBadgeProps> = ({
  duration,
  tooltip,
}) => {
  return (
    <Tooltip title={tooltip}>
      <span className="chart-duration">{duration}</span>
    </Tooltip>
  );
};
